import React from "react";

import { Count } from "@/components/Count";

type Props = {
  itemCount?: number;
};

const ItemCount: React.FC<Props> = ({ itemCount }) => {
  if (typeof itemCount !== "number") {
    return <div></div>;
  }

  return (
    <div>
      {itemCount > 0 && (
        <div className="font-bold text-xs">
          <Count amount={itemCount} noun="result" plural="results" />
        </div>
      )}
    </div>
  );
};

export default ItemCount;
